module.exports = __webpack_public_path__ + "static/img/xz.266cc83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xz.jpg
// module id = r1BJ
// module chunks = 1